import { Grid } from "@material-ui/core";
import React from "react";
import { NumberInput, SelectInput, TextInput } from "react-admin";
import { Form } from "react-final-form";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { HourMinuteInput } from "../../../../Components/HourMinuteInput";
import { GetPbhCarrierType } from "../../../../Enums/PbhCarrierType";
import { GetPbhRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
import { GetPbhRemoveReasonType } from "../../../../Enums/PbhRemoveReasonType";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import PbhUnserviceableStatusChip from "../Statu/PbhUnserviceableStatusChip";
import { PbhUnserviceableReplenishmentType } from "../../../../../src/Constants/Constant";
import { getTkCargoTrackingUrl } from "../../../../Helper/TkCargoHelper";
import { useAuth } from "@airborne/react-admin";
import { OpenInNew } from "@material-ui/icons";
import { CarrierType } from "../../../../Enums/CarrierType";

const UnserviceableView = props => {
  const { user } = useAuth();

  return (
    <>
      <Form
        initialValues={props.unserviceable}
        onSubmit={() => {}}
        render={({ values }) => (
          <form>
            <>
              <Grid container justifyContent="space-around" spacing={2}>
                <Grid item xs={12} container justifyContent="space-around">
                  <SectionTitle label="Core Unit Info" />
                  <PbhUnserviceableStatusChip unserviceable={props.unserviceable} />
                </Grid>
                <Separator />
                <Grid item xs={12} container justifyContent="space-around">
                  <Grid item xs={6} container direction="column" alignItems="center">
                    <Grid item xs={10}>
                      <TextInput source="pn" label="PN" fullWidth variant="outlined" disabled />
                      <TextInput source="sn" label="SN" fullWidth variant="outlined" disabled />
                      <TextInput source="ac" label="AC" fullWidth variant="outlined" disabled />
                      <NumberInput source="batch" label="Batch" fullWidth variant="outlined" disabled />
                      <CustomDatetime
                        fullWidth
                        source="removeDateFromAc"
                        label="Remove Date from AC"
                        variant="outlined"
                        showTime
                        disabled
                      />

                      <Grid container spacing={1}>
                        <Grid item xs>
                          <HourMinuteInput
                            source="tso"
                            label="TSO (Hour)"
                            hourDigits={7}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="cso" label="CSO (Cycle)" fullWidth variant="outlined" disabled />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="dso" label="DSO (Days)" fullWidth variant="outlined" disabled />
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item xs>
                          <HourMinuteInput
                            source="tsr"
                            label="TSR (Hour)"
                            hourDigits={7}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="csr" label="CSR (Cycle)" fullWidth variant="outlined" disabled />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="dsr" label="DSR (Days)" fullWidth variant="outlined" disabled />
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item xs>
                          <HourMinuteInput
                            source="tsn"
                            label="TSN (Hour)"
                            hourDigits={7}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="csn" label="CSN (Cycle)" fullWidth variant="outlined" disabled />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="dsn" label="DSN (Days)" fullWidth variant="outlined" disabled />
                        </Grid>
                      </Grid>
                      <Grid item container spacing={1}>
                        <Grid item xs>
                          <HourMinuteInput
                            source="tsi"
                            label="TSI (Hour)"
                            hourDigits={7}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="csi" label="CSI (Cycle)" fullWidth variant="outlined" disabled />
                        </Grid>
                        <Grid item xs>
                          <NumberInput source="dsi" label="DSI (Days)" fullWidth variant="outlined" disabled />
                        </Grid>
                      </Grid>
                      <TextInput source="dom" label="DOM" fullWidth variant="outlined" disabled />
                      <TextInput source="nha" label="NHA" fullWidth variant="outlined" disabled />
                      <SelectInput
                        source="replenishmentReason"
                        label="REPLENISHMENT REASON"
                        optionText="replenishmentTypes"
                        optionValue="value"
                        choices={PbhUnserviceableReplenishmentType}
                        fullWidth
                        resettable
                        disabled
                        variant="outlined"
                      />
                      <TextInput
                        source="rejectionRemark"
                        label="Rejection Remark"
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6} container direction="column" alignItems="center">
                    <Grid item xs={10}>
                      {props.unserviceable?.awb && !user?.isCustomer && (
                        <a
                          href={getTkCargoTrackingUrl(props.unserviceable.awb)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#C90C0F", textDecoration: "none", fontSize: "12px" }}
                        >
                          <OpenInNew style={{ fontSize: 12, marginRight: 4 }} />
                          Track on TK Cargo
                        </a>
                      )}
                      <TextInput source="awb" label="AWB" fullWidth variant="outlined" disabled />
                      <TextInput source="flightNo" label="Flight No" fullWidth variant="outlined" disabled />
                      <SelectInput
                        source="carrierEnum"
                        label="Carrier Type"
                        choices={GetPbhCarrierType}
                        optionText="Description"
                        optionValue="Value"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <CustomDatetime
                        fullWidth
                        source="forwardDateToCarrier"
                        label="Forward Date To Carrier"
                        variant="outlined"
                        showTime
                        disabled
                      />
                      <CustomDatetime
                        fullWidth
                        source="estimatedDeliveryDate"
                        label="Estimated Delivery Date"
                        variant="outlined"
                        showTime
                        disabled
                      />
                      <SelectInput
                        source="removeReasonType"
                        label="Remove Reason Type"
                        choices={GetPbhRemoveReasonType}
                        optionText="Description"
                        optionValue="Value"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <SelectInput
                        source="removeReasonSubType"
                        label="Remove Reason Sub Type"
                        choices={GetPbhRemoveReasonSubType(values.removeReasonType)}
                        optionText="Description"
                        optionValue="Value"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        source="remark"
                        label="Remarks of Customer"
                        multiline
                        fullWidth
                        rows={4}
                        variant="outlined"
                        disabled
                      />
                      <TextInput
                        source="removalReasonDetail"
                        label="Removal Reason Detail"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextInput source="nla" label="NLA" fullWidth variant="outlined" disabled />
                      <TextInput source="adSbMod" label="AD(SB/MOD)" fullWidth variant="outlined" disabled />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Unserviceable} />
    </>
  );
};

const PbhRequestUnserviceableView = props => {
  return <UnserviceableView unserviceable={props.unserviceable} requestDetail={props.requestDetail} />;
};

export default PbhRequestUnserviceableView;
